<!-- condition-sheet.component.html -->

<ng-container *ngIf="data$ | async as condition; else loadingTpl">
  <article class="page">
    <header class="page-title" aria-label="Scroll to top" [class.at-top]="(atTop$ | async)"
      [attr.role]="(atTop$ | async) ? null : 'button'" [attr.tabindex]="(atTop$ | async) ? -1 : 0"
      (click)="onTitleClick($event)" (keydown.enter)="onTitleClick($event)" (keydown.space)="onTitleClick($event)">
      <nav class="breadcrumb" *ngIf="path$ | async as path">

        <ng-container *ngFor="let seg of path; let last = last">
          {{ seg.label }}
          <span class="sep" *ngIf="!last"> → </span>
        </ng-container>
      </nav>
      <h1>{{ condition.title }}</h1>
      <svg class="to-top-icon" viewBox="0 0 24 24" aria-hidden="true">
        <!-- top boundary line -->
        <path d="M4 5h16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        <!-- up arrow -->
        <path d="M12 19V9m0 0l-5 5m5-5l5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>

    </header>
    <div class="page-body">
      <ng-container *ngIf="condition.sections.length > 0; else noSectionsTpl">
        <ng-container *ngFor="let section of condition.sections">
          <app-section [section]="section"></app-section>
        </ng-container>
      </ng-container>
    </div>

    <footer class="page-footer">
      <p>
        <strong>Medical Disclaimer:</strong>
        The content on this site is for educational purposes only and is not a substitute for professional medical advice,
        diagnosis, or treatment.
        If you think you may be experiencing a medical emergency, call 911 or your local emergency number immediately.
        Always consult a licensed healthcare professional with questions about a medical condition.
      </p>

      <p>
        <strong>Artificial Intelligence Use:</strong>
        Portions of this site’s content were generated or assisted by AI and reviewed by Erik Romano, MD; however, errors
        or omissions may occur.
      </p>

<p>
  <strong>USMLE®</strong> is a registered trademark of the Federation of State Medical Boards (FSMB) and the National
  Board of Medical Examiners (NBME).
  Doctogenic and Roscoe &amp; Romano are not affiliated with, sponsored by, or endorsed by the USMLE, FSMB, or NBME. Neither FSMB nor NBME has reviewed or approved this content. “USMLE Step 1” and “USMLE Step 2 CK” are used only to identify the relevant examinations.
</p>


      <p class="copyright">© 2026 Roscoe &amp; Romano. All rights reserved.</p>
    </footer>

  </article>
</ng-container>

<ng-template #noSectionsTpl>
  <p>No sections available for this condition.</p>
</ng-template>

<ng-template #loadingTpl>
  <p>Loading entry…</p>
</ng-template>
